// eslint-disable-next-line import/no-extraneous-dependencies
import { nanoid } from 'nanoid';
import Overlay from './overlay';

/* eslint-disable */
export const defaultIcon = '<svg width="24" height="24" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 4C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20V14C6 12.8954 6.89543 12 8 12H16C17.1046 12 18 12.8954 18 14V20C19.1046 20 20 19.1046 20 18V9.24264C20 8.71221 19.7893 8.2035 19.4142 7.82843L18 6.41421V7C18 8.10457 17.1046 9 16 9H8C6.89543 9 6 8.10457 6 7L6 4ZM16 22H8H6C3.79086 22 2 20.2091 2 18V6C2 3.79086 3.79086 2 6 2H8H14.7574H15.5858C16.1162 2 16.6249 2.21071 17 2.58579L17.2071 2.79289L17.4142 3C17.438 3.02375 17.4611 3.04804 17.4835 3.07284C17.5181 3.10509 17.5522 3.138 17.5858 3.17157L20.8284 6.41421C21.5786 7.16436 22 8.18177 22 9.24264V18C22 20.2091 20.2091 22 18 22H16ZM16 20V14H8V20H16ZM16 4.43288C15.6482 4.15394 15.2107 4 14.7574 4H8V7H16V4.43288Z" fill="white"/></svg>';
export const savedIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M37.8,7.81,29.59.18a.69.69,0,0,0-.5-.18H2.36A2.31,2.31,0,0,0,0,2.23V35.67A2.39,2.39,0,0,0,2.36,38H35.8A2.26,2.26,0,0,0,38,35.67V8.36A.72.72,0,0,0,37.8,7.81ZM8.36,1.52H26.6V16H8.36ZM36.48,35.67a.74.74,0,0,1-.68.81H2.36a.88.88,0,0,1-.84-.81V2.23a.79.79,0,0,1,.84-.71H6.84V16.67a.88.88,0,0,0,.84.81H27.44a.74.74,0,0,0,.68-.81V1.52h.67l7.69,7.17Z" style="fill:#fff"/><rect x="22.04" y="3.8" width="1.52" height="9.88" style="fill:#fff"/><path d="M27.45,24.32H7.68a.76.76,0,0,0,0,1.52H27.45a.76.76,0,0,0,0-1.52Z" style="fill:#fff"/><path d="M27.45,28.12H7.68a.76.76,0,1,0,0,1.52H27.45a.76.76,0,0,0,0-1.52Z" style="fill:#fff"/><path d="M27.45,31.92H7.68a.76.76,0,0,0,0,1.52H27.45a.76.76,0,0,0,0-1.52Z" style="fill:#fff"/><rect width="45" height="45" style="fill:none"/><path d="M32.72,45A12.45,12.45,0,1,1,45,32.55,12.38,12.38,0,0,1,32.72,45Zm0-22.73A10.28,10.28,0,1,0,42.86,32.55,10.22,10.22,0,0,0,32.72,22.27Z" style="fill:#fff"/><path d="M32.72,21.6a11,11,0,1,0,10.8,10.95A10.88,10.88,0,0,0,32.72,21.6Z" style="fill:#399e39"/><path d="M40,28.52l-9.14,9.62a.54.54,0,0,1-.4.17.46.46,0,0,1-.4-.17l-4.57-5a.59.59,0,0,1-.17-.4.61.61,0,0,1,.17-.41l.8-.81a.55.55,0,0,1,.8,0L30.27,35a.28.28,0,0,0,.4,0l7.71-8a.55.55,0,0,1,.8,0l.8.81a.49.49,0,0,1,0,.75Z" style="fill:#fff"/></g></g></svg>';
export const errorIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M37.8,7.81,29.59.18a.69.69,0,0,0-.5-.18H2.36A2.31,2.31,0,0,0,0,2.23V35.67A2.39,2.39,0,0,0,2.36,38H35.8A2.26,2.26,0,0,0,38,35.67V8.36A.72.72,0,0,0,37.8,7.81ZM8.36,1.52H26.6V16H8.36ZM36.48,35.67a.74.74,0,0,1-.68.81H2.36a.88.88,0,0,1-.84-.81V2.23a.79.79,0,0,1,.84-.71H6.84V16.67a.88.88,0,0,0,.84.81H27.44a.74.74,0,0,0,.68-.81V1.52h.67l7.69,7.17Z" style="fill:#fff"/><rect x="22.04" y="3.8" width="1.52" height="9.88" style="fill:#fff"/><path d="M27.45,24.32H7.68a.76.76,0,0,0,0,1.52H27.45a.76.76,0,0,0,0-1.52Z" style="fill:#fff"/><path d="M27.45,28.12H7.68a.76.76,0,1,0,0,1.52H27.45a.76.76,0,0,0,0-1.52Z" style="fill:#fff"/><path d="M27.45,31.92H7.68a.76.76,0,0,0,0,1.52H27.45a.76.76,0,0,0,0-1.52Z" style="fill:#fff"/><rect width="45" height="45" style="fill:none"/><path d="M32.72,45A12.45,12.45,0,1,1,45,32.55,12.38,12.38,0,0,1,32.72,45Zm0-22.73A10.28,10.28,0,1,0,42.86,32.55,10.22,10.22,0,0,0,32.72,22.27Z" style="fill:#fff"/><path d="M32.72,21.6a11,11,0,1,0,10.8,10.95A10.88,10.88,0,0,0,32.72,21.6Z" style="fill:#c1272d"/><path d="M28,28.13a1.06,1.06,0,0,1,1.12-1,1.33,1.33,0,0,1,.94.46L33,30.72l3.45-3.24a1.55,1.55,0,0,1,.92-.25,1,1,0,0,1,.69.33,1.13,1.13,0,0,1,.28.68,1.38,1.38,0,0,1-.26.89l-3.51,3.31,3.32,3.61A1.44,1.44,0,0,1,38,37a1.07,1.07,0,0,1-.33.66,1,1,0,0,1-.71.28,1.59,1.59,0,0,1-.9-.32L32.84,34l-3.5,3.31a1.33,1.33,0,0,1-1,.38,1.07,1.07,0,0,1-1.05-1.1,1.45,1.45,0,0,1,.38-.94l3.57-3.36L28.32,29.1A1.46,1.46,0,0,1,28,28.13Z" style="fill:#fff"/></g></g></svg>';

// This component is not used anymore. It will be removed in the future.
export default class SaveAndContinueLater {
  constructor(continueLater, hiddenSubmitter, emailAnswerFinder, formID, apiURL, tranlatedTexts) {
    Object.assign(this, { continueLater, hiddenSubmitter, emailAnswerFinder, formID, apiURL, tranlatedTexts });

    this.inited = false;
    this.states = Object.freeze({ default: 0, saving: 1, saved: 2, error: 3 });
    this.formId = document.forms[0].getAttribute('id');
    this.overlay = new Overlay({ hasSaveAndContinueLater: true });
    this.initiate = this.initiate.bind(this);
    this.openSaveAndContinueLaterModal = this.openSaveAndContinueLaterModal.bind(this);
    this.continue = this.continue.bind(this);

    this.changeState(this.states.default);
  }

  /**
   * Creates the initial submission
   */
  initiate() {
    if (!this.inited) {
      this.inited = true;
      this.sessionID = this.generateSessionID();
      this.token = this.generateToken();
      global.JotForm.sessionID = this.sessionID;
      global.JotForm.submissionToken = this.token;
    } else {
      this.sessionID = global.JotForm.sessionID;
      this.token = global.JotForm.submissionToken || this.generateToken();
    }
  }


  openSaveAndContinueLaterModal() {
    this.initiate();
    this.continueLater.active = true;
    this.hiddenSubmitter();
    this.overlay.openSaveAndContinueModal();
  }

  continue() {
    this.inited = true;
    this.sessionID = global.JotForm.sessionID;
    this.submissionToken = global.JotForm.submissionToken;
    this.changeState(this.states.saved);
  }

  changeState(newState) {
    const stateElement = document.querySelector('.jf-saclState');
    const progressSacl = document.querySelector('.jfProgress-sacl');
    if (!stateElement || !progressSacl) {
      return;
    }

    let icon;
    let text;

    switch (newState) {
      case this.states.default:
        icon = defaultIcon;
        text = this.tranlatedTexts['Save & Continue Later'];
        break;
      case this.states.saved:
        icon = savedIcon;
        text = this.tranlatedTexts['Answers saved'];
        break;
      case this.states.error:
        icon = errorIcon;
        text = this.tranlatedTexts['Answers not saved'];
        break;
      default:
        icon = defaultIcon;
        text = this.tranlatedTexts['Save & Continue Later'];
        console.info('No such state implemented:', newState);
        break;
    }

    progressSacl.setAttribute('data-tooltip-msg', text);
    stateElement.innerHTML = `<span class="sacl-state-icon">${icon}</span>`;
  }

  generateSessionID() {
    const uniq = nanoid(8);
    return `JF-S4L-${uniq}`;
  }

  generateToken() {
    const uniq = nanoid(8);
    const formIdLastNumber = this.formId.toString().slice(-1) / 1;
    const checkSum = (formIdLastNumber * 4) + 7;
    return `JF-${uniq}-${checkSum}`;
  }

}
